export default "__VITE_ASSET__CG4EDgY8__"